module.exports = {"restApiUrl":"https://servis13.supersport.hr/api","apiKey":"Prod2020MeanIt"};